import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';
import { TranslationsForEntity, ALL_TRANSLATIONS } from 'app/constants/schemas/translations';

export interface IBrandExternalSite extends IEntity {
  attributes: {
    /**
     * Id for this External Site.
     */
    id: EntityStringId;
    /**
     * The hostname for the external site. c.f. {@link envUri} is the hostname mutated
     * for the current environment.
     */
    hostname: string;
    /**
     * The {@link hostname} adjusted for the current environment.
     */
    readonly envUri: string;
    /**
     * A flag indicating if this external site has been configured to support `branch.dev`
     * domains or if it should revert to the default handling for branches.
     */
    devSubdomain: boolean;
  };
}

export type BrandExternalSite = Entity<IBrandExternalSite>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandExternalSite: IEntityType<IBrandExternalSite> = vmClient.defineClass({
  typeName: 'BrandExternalSite',
  version: 2,
  persisted: true,
  attributes: {
    hostname: {
      type: 'string',
      notNull: true,
    },
    envUri: {
      type: 'string',
      notNull: true,
    },
    devSubdomain: {
      type: 'boolean',
      notNull: true,
    },
  },
});

export const BrandExternalSiteTranslations: Partial<TranslationsForEntity<IBrandExternalSite>> = {
  id: {
    getLabel: (t) => t('entity-fields.BrandExternalSite.id.label'),
  },
  hostname: {
    getLabel: (t) => t('entity-fields.BrandExternalSite.hostname.label'),
    getDescription: (t) => t('entity-fields.BrandExternalSite.hostname.description'),
  },
  envUri: {
    getLabel: (t) => t('entity-fields.BrandExternalSite.envUri.label'),
    getDescription: (t) => t('entity-fields.BrandExternalSite.envUri.description'),
  },
  devSubdomain: {
    getLabel: (t) => '',
    getInlineLabel: (t) => t('entity-fields.BrandExternalSite.devSubdomain.inline-label'),
    getDescription: (t) => t('entity-fields.BrandExternalSite.devSubdomain.description'),
  },
};

ALL_TRANSLATIONS.set(BrandExternalSite, BrandExternalSiteTranslations);
